import React from 'react';
const Header = () => {
  return (
    <div className='header1'>
      <div className='headerCont'>
        <div className='typical'>

        </div>
        <div className="headingtext">

        <h4>The First Choice When It Comes To Art.</h4>
        <h5>Framing And Editing Covered.</h5>
        <h6>Your Request Is Our Concern</h6>
        </div>
      </div>
    </div>
  );
}

export default Header;
